import { AxiosPromise } from 'axios';
import api from './api';

// eslint-disable-next-line import/prefer-default-export
export function getLogout() {
  return new Promise<AxiosPromise<{
    url: string;
  }>>((resolve, reject) => {
    try {
      api
        .get('/auth/logout')
        .then((response: any) => {
          resolve(response);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}
